export enum DialogActionType {
  VIEW = "view",
  EDIT = "edit",
  ADD = "add",
  DEL = "del",
  CANCEL = "cancel",
}
